import { selectedDayKeys } from "./scheduleFormat";

/**
 * 편집 중인 스케줄의 저장 전 점검 항목. 저장을 막지는 않고 안내만 한다.
 * @returns {{ section: number, level: 'ok'|'warn', text: string }[]}
 */
export function buildChecks(detail, t) {
    const checks = [];
    const push = (section, ok, okText, warnText) =>
        checks.push({ section, level: ok ? "ok" : "warn", text: ok ? okText : warnText });

    const hasName = !!(detail.schdCtrlName && String(detail.schdCtrlName).trim());
    push(1, hasName, t("스케줄명이 입력되었습니다."), t("스케줄명을 입력하세요."));

    const dayCount = selectedDayKeys(detail.repeatConfig).length;
    push(
        1,
        dayCount > 0,
        `${t("제어 요일")} ${dayCount}${t("일이 선택되었습니다.")}`,
        t("제어 요일을 하나 이상 선택하세요."),
    );

    if (detail.startDate && detail.endDate && detail.startDate > detail.endDate) {
        checks.push({ section: 1, level: "warn", text: t("유효 기간의 시작일이 종료일보다 늦습니다.") });
    }

    const emptyTypes = detail.targets.filter(
        (target) =>
            !detail.groups.some((g) => g.equipType == target.equipType) &&
            !detail.equips.some((e) => e.equipType == target.equipType),
    );
    const targetCount = detail.groups.length + detail.equips.length;
    push(
        2,
        detail.targets.length > 0 && emptyTypes.length === 0 && targetCount > 0,
        `${t("제어 대상")} ${t("그룹")} ${detail.groups.length}${t("개")} · ${t("설비")} ${detail.equips.length}${t("대")}${t("가 지정되었습니다.")}`,
        detail.targets.length === 0
            ? t("제어할 설비 유형을 선택하세요.")
            : t("선택한 설비 유형 중 그룹/설비가 지정되지 않은 유형이 있습니다."),
    );

    push(
        3,
        detail.events.length > 0,
        `${t("스케줄 설정")} ${detail.events.length}${t("건이 등록되었습니다.")}`,
        t("스케줄 설정을 하나 이상 추가하세요."),
    );

    const orphan = detail.events.filter(
        (e) => e.equipType && !detail.targets.some((target) => target.equipType == e.equipType),
    );
    if (orphan.length) {
        checks.push({
            section: 3,
            level: "warn",
            text: `${orphan.length}${t("건의 이벤트가 제어 대상에 없는 설비 유형을 사용합니다.")}`,
        });
    }
    return checks;
}
